// frontend/src/components/Footer.jsx
import React from "react";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; 
import './Footer.css';

const Footer = ({ contactsData }) => { 
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();



  const hasContacts = contactsData && Object.keys(contactsData).length > 0;
  return (
<footer className="footer" id="footer">
      <div className="footer-container">
        <div className="top-row">
          <p className="text-sm">
            {t('footer.copyright', { year: currentYear })}
          </p>
          

          {hasContacts ? (
            <div className="contact-container">
              <div className="contact-block"> 
                
               
                {contactsData.email_address && (
                  <p className="contact-item">
                    <a href={`mailto:${contactsData.email_address}`} className="contact-link">
                      {contactsData.email_address}
                    </a>
                  </p>
                )}

                {contactsData.phone_number && (
                  <p className="contact-item">
                    <a href={`tel:${contactsData.phone_number}`} className="contact-link">
                      {contactsData.phone_number}
                    </a>
                  </p>
                )}
                
               
                {contactsData.telegram_url && 
                  <p className="contact-item">
                    <a href={contactsData.telegram_url} target="_blank" rel="noopener noreferrer" className="contact-link">Telegram</a>
                  </p>
                }
                  
                {contactsData.linkedin_url && 
                  <p className="contact-item">
                    <a href={contactsData.linkedin_url} target="_blank" rel="noopener noreferrer" className="contact-link">LinkedIn</a>
                  </p>
                }
                  
                {contactsData.github_url && 
                  <p className="contact-item">
                    <a href={contactsData.github_url} target="_blank" rel="noopener noreferrer" className="contact-link">GitHub</a>
                  </p>
                }

              </div>
            </div>
          ) : (
            <div className="contact-container">
              <p>{t('footer.message')}</p>
            </div>
          )}

        </div>
        <div className="link-container">
          <Link to="/#about" className="hover:underline">{t('footer.footerAbout')}</Link>
          <Link to="/#services" className="hover:underline">{t('footer.footerServices')}</Link>
          <Link to="/#portfolio" className="hover:underline">{t('footer.footerPortfolio')}</Link>
          <Link to="/#reviews" className="hover:underline">{t('footer.footerReviews')}</Link>
          <Link to="/#contact" className="hover:underline">{t('footer.footerContact')}</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;